"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.status = exports.blocked_reason = exports.role = exports.name = void 0;
/**
 * Name of the security groups the online account belongs to
 */
exports.name = {
    ONLINE_CUSTOMERS: 'online_customers',
    DEBT_MANAGERS: 'debt_managers'
};
/**
 * Security role of the consumers online account
 */
exports.role = {
    ADMIN: 'admin',
    USER: 'user'
};
/**
 * Reason for account blocking
 */
exports.blocked_reason = {
    DEBT_MANAGEMENT: 'debt_management',
    FALSE_LOGIN_ATTEMPTS: 'false_login_attempts'
};
/**
 * Status of the online account
 */
exports.status = {
    ACTIVATED: 'actived',
    ACTIVE: 'active',
    AWAIT_ACTIVIATION: 'await_activation',
    BLOCKED: 'blocked',
    CREATED: 'created',
    PASSWORD_RESET: 'password_reset'
};
